import {Injectable} from "@angular/core";
import {ApiClient} from "../../tools/api-client";
import {Observable} from "rxjs";
import {LocalizationStrings} from "../../i18n/i18n-model";

@Injectable()
export class TranslationService {

  constructor(private readonly apiClient: ApiClient) {
  }

  saveTranslations(translations: TranslatedString[]): Observable<void> {
    return this.apiClient.put("/api/translations", {translations: translations});
  }

  addTranslation(
    code: string,
    flag: string,
    uiTranslations: Translation[],
  ): Observable<void> {
    return this.apiClient.post("/api/translations/languages", {
      code: code,
      flag: flag,
      uiTranslations: uiTranslations,
    });
  }
}

export interface TranslatedString {
  language: string;
  key: keyof LocalizationStrings;
  translation: string;
}

export interface Translation {
  key: string;
  value: string;
}
